import { CONTACT_DATA } from './contact.constants';

export const WHATSAPP_API_URL = 'https://api.whatsapp.com/send/';

export const WHATSAPP_GENERAL_SUPPORT_LINK = `${WHATSAPP_API_URL}?phone=945537324&text=Hola%2C+tengo+una+duda+sobre+la+tienda+virtual+y+me+gustar%C3%ADa+que+me+apoyen.&type=phone_number&app_absent=0`;

export const WHATSAPP_CUSTOMER_SERVICE_LINK = `${WHATSAPP_API_URL}?phone=+51${
  CONTACT_DATA.NUMBER_CONTACT
}&text=${CONTACT_DATA.MESSAGE_WSP.replace(' ', '%20')}`;
